<div class="form-group" [formGroup]="form">
  @if (label) {
    <label
      [for]="id"
      class="form-label"
      >
      {{ label }}
      @if (required) {
        <span class="required"> * </span>
      }
    </label>
  }
  <textarea
    [id]="id"
    [formControlName]="id"
    [disabled]="disabled"
    [readonly]="readonly"
    [rows]="rows"
    [maxLength]="maxLength"
    class="form-control"
    (change)="onChange($event)"
  >{{ value }}</textarea>
</div>
